import { mergeDeepLeft } from 'ramda';
import React, {
  createContext,
  useContext,
  useDebugValue,
  useMemo,
} from 'react';
import {
  businessConfigs,
  IBusinessConfig,
  IBusinessConfigs,
  ICustomBusinessConfigs,
} from '../../Features/Delsystem/_Common/Const/BusinessConfigs';
interface IProviderProps {
  value?: ICustomBusinessConfigs;
}
const emptyConfig = {};
const BusinessConfigContext = createContext<IBusinessConfigs>(emptyConfig);
BusinessConfigContext.displayName = 'BusinessConfigContext';

export const useBusinessConfigContext = () =>
  useContext<IBusinessConfigs>(BusinessConfigContext);

export const useBusinessConfig = (
  collectionName: string | undefined
): IBusinessConfig | undefined => {
  const configContext = useBusinessConfigContext();
  const result =
    collectionName == null ? undefined : configContext[collectionName];
  useDebugValue(result);
  return result;
};

/**
 * Provider för businessconfigs. Skapar ett context där med det angivna värdet är mergad med överliggande context.
 */
export const BusinessConfigContextProvider: React.FunctionComponent<
  React.PropsWithChildren<IProviderProps>
> = props => {
  const baseConfig = useBusinessConfigContext();
  const result = useMemo(
    () =>
      props.value == null
        ? baseConfig
        : (mergeDeepLeft(props.value, baseConfig) as IBusinessConfigs),
    [baseConfig, props.value]
  );
  return (
    <BusinessConfigContext.Provider value={result}>
      {props.children}
    </BusinessConfigContext.Provider>
  );
};
/** Provider för businessconfig som sätter default-konfigurationen från XXBusinessConfig.tsx filerna.
 * Som en egen komponten för att kunna vänta lite med initiering av businessconfigs() som orsakat cirkelberoenden.
 */
export const GlobalBusinessConfigContextProvider: React.FunctionComponent<
  React.PropsWithChildren<{}>
> = props => {
  const globalBusinessconfigs = businessConfigs();
  return (
    <BusinessConfigContext.Provider value={globalBusinessconfigs}>
      {props.children}
    </BusinessConfigContext.Provider>
  );
};
